import img1 from "../assets/img1.jpg";
import img2 from "../assets/img2.jpg";
import img3 from "../assets/img3.jpg";
import slideimg1 from "../assets/slideimg1.jpg";
import img7 from "../assets/img7.jpg";
import img8 from "../assets/img8.jpg";
import img9 from "../assets/img9.jpg";
import img6 from "../assets/img6.jpg";

export const OverviewContent = [
  {
    label: "Giftcard",
    title: "Travel With Grace",
    content:
      "Traverse the globe without limits. We’ll take on the hassle of planning lavish flight, sea, and ground accommodations that spare no comfort.",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Bite Into Opulence",
    content:
      "Experience a variety of global tastes and textures. From three-star Michelin restaurants to private rooftop wine tastings, we craft your culinary journey with the precision of local expertise",
    btn: "Purchase card",
  },
  {
    title: "Real Estate",
    content:
      "Global property masters with access to off-show case properties and master promoting abilities.Regardless of whether the longing is to purchase, sell or lease a five-star living arrangement, our specialist will locate the ideal ...",
    btn: "Purchase card",
  },
  {
    title: "Commemorate your Journey",
    content:
      "Embark on a personalized outing to find meaningful gifts and mementos. Your dedicated concierge team will map out the ....",
    btn: "Purchase card",
  },
  {
    title: "Prestigious wine-tasting  ",
    content:
      "Our bespoke schedules are arranged around you and your inclinations, to make a private interesting visit for your gathering. We can organize wine visits to... ",
  },
  {
    title: "Private & Exclusive Event",
    content:
      "We produce amazing gatherings and festivities for the world's most perceiving crowd. Prestigious for making unique encounters in energizing looked for after areas everywhere throughout the ....",
  },
];
export const HomeServiceCards = [
  {
    img: <img src={img1} alt="img" />,
    title: "A GLOBAL TEAM DESIGNED JUST FOR YOU",
    content:
      "Our dedicated concierge team creates luxury journeys to meet your unique needs....",
  },
  {
    img: <img src={img2} alt="img" />,
    title: "MORE THAN A PREMIUM CONCIERGE SERVICE",
    content:
      "Owing to our relationship and industry expertise, we are able to implement your expectations",
  },
  {
    img: <img src={img3} alt="img" />,
    title: "LUXURY TAILOR-MADE TRAVEL AMAZING DESTINATIONS",
    content:
      "Every guest is different which is why we have learned to adapt each time....",
  },
];
export const homeslide = [
  {
    img: <img src={slideimg1} alt="slide" />,

    content:
      "Bali is an Indonesian island known for its forested volcanic mountains, iconic rice paddies, beaches and coral reefs. The island is home to religious sites such as cliffside Uluwatu Temple. To the south, the beachside city of Kuta has lively bars, while Seminyak, Sanur and Nusa Dua are popular resort towns. The island is also known for its yoga and meditation retreats. The top destination for personal discovery enables you to descend into pure tranquility and ...",
  },
  {
    img: <img src={slideimg1} alt="slide" />,

    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet,  and ...",
  },
  {
    img: <img src={slideimg1} alt="slide" />,

    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet,  and ...",
  },
  {
    img: <img src={slideimg1} alt="slide" />,

    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet,  and ...",
  },
];

export const upcomingEvents = [
  {
    img: <img src={img7} alt="slide" />,
    event: "Super Bowl LIV",
    day: "Sun, Feb 02",
    location: "Hard Rock Stadiumd",
  },
  {
    img: <img src={img8} alt="slide" />,
    event: "Miami Beach Art Basel",
    day: "Thu, Dec 05",
    location: "South Beach",
  },
  {
    img: <img src={img9} alt="slide" />,
    event: "ABU DHABI FORMULA 1..",
    day: "Fri, Nov 29",
    location: "Yas Island",
  },
  {
    img: <img src={img6} alt="slide" />,
    event: "OKTOBERFEST...",
    day: "Sat, Sep 21",
    location: "Theresienwiese",
  },
];
